import React, { ReactElement } from "react";

import BookDemo from "./BookDemo";
import Product from "./Product";
import { Container, Brand, LogoContainer, LogoText, ProductContainer, Anchor } from "./styles";

import * as Logos from "~/components/icons/Logo";

const platformItems: ReactElement[] = [
  <span key={1}>{"Work with any company, regardless of the Travel Rule protocol they use"}</span>,
  <span key={2}>{"Implement your own risk-based approach to automate data transfers to counterparty exchanges"}</span>,
  <span key={3}>{"Send and receive Travel Rule transfers today. No integration is required to get started"}</span>,
];

const walletItems: ReactElement[] = [
  <span key={1}>{"Seamlessly integrate Wallet ID’s prebuilt UI components into your product"}</span>,
  <span key={2}>{"Identify the counterparty wallet and Travel Rule transfers"}</span>,
  <span key={3}>{"Collect missing counterparty data for automated Travel Rule data flows"}</span>,
];

export default function Products() {
  return (
    <Container>
      <Brand>
        <LogoContainer>
          <Logos.Logo style={{ width: "90%", height: "90%" }} />
        </LogoContainer>
        <LogoText>PRODUCTS</LogoText>
      </Brand>
      <ProductContainer>
        <Product
          title="Crypto Travel Rule Compliance Platform"
          items={platformItems}
          bottomText={
            <span>
              Learn more about{" "}
              <Anchor href="https://notabene.id/product-travel-rule" target="_blank" rel="noreferrer">
                Travel Rule Compliance Solution
              </Anchor>
            </span>
          }
        />
        <Product
          title="Counterparty Crypto Wallet ID"
          items={walletItems}
          bottomText={
            <span>
              Learn more about{" "}
              <Anchor href="https://notabene.id/wallet-identification" target="_blank" rel="noreferrer">
                Counterparty Crypto Wallet ID
              </Anchor>
            </span>
          }
        />
        <BookDemo />
      </ProductContainer>
    </Container>
  );
}
